import { parseDate, sortDates } from "../../../utilities";

export const SMALLBOATS_COLUMNS = [
  {
    Header: "Рег. номер",
    accessor: "regNum",
  },
  {
    Header: "Заводской номер судна",
    accessor: "boatVin",
  },
  {
    Header: "ФИО Собственника",
    accessor: "owner",
  },
  {
    Header: "Идентификационный номер",
    accessor: "ownerPersNum",
  },
  {
    Header: "Наименование организации",
    accessor: "leName",
  },
  {
    Header: "УНП",
    accessor: "leUnp",
  },
  {
    Header: "Адрес, телефон",
    accessor: "address",
  },
];

export const CERTIFICATES_COLUMNS = [
  {
    Header: "Номер удостоверения",
    accessor: "licenseNum",
  },
  {
    Header: "ФИО",
    accessor: "fio",
  },
  {
    Header: "Дата рождения",
    accessor: "birthDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Идентификационный номер",
    accessor: "persNum",
  },
  {
    Header: "Тип удостоверения",
    accessor: "ltName",
  },
  {
    Header: "Дата выдачи",
    accessor: "licenseDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Действителен до",
    accessor: "licenseDateEnd",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Статус",
    accessor: "status",
  },
];
export const BUILDING_COLUMNS = [
  {
    Header: "Наименование ЮЛ (ФИО ФЛ, ИП) эксплуатанта базы",
    accessor: "ownerLeName",
  },
  {
    Header: "Адрес и телефон эксплуатанта базы",
    accessor: "ownerContact",
  },
  {
    Header: "УНП",
    accessor: "ownerUnp",
  },
  {
    Header: "Местонахождение и телефон базы",
    accessor: "baseContact",
  },
  {
    Header:
      "Наименование должности, ФИО, ответственного за эксплуатацию базы, номер и дата приказа о назначении",
    accessor: "responData",
  },
  {
    Header: "Дата последнего обследования",
    accessor: "checkDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Результат последнего обследования",
    accessor: "statusName",
  },
  {
    Header: "Участок",
    accessor: "sectionName",
  },
  { Header: "Статус", accessor: "bpStatusName" },
  {
    Header: "Примечание",
    accessor: "note",
  },
];
export const SMALLBOATS_ADMIN_COLUMNS = [
  {
    Header: "Рег. номер заявления",
    accessor: "appNum",
  },
  {
    Header: "Дата регистрации заявления",
    accessor: "appDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "ФИО",
    accessor: "fio",
  },
  {
    Header: "Ид. номер заявителя",
    accessor: "persNum",
  },
  {
    Header: "Наим. организации",
    accessor: "nameLe",
  },
  {
    Header: "УНП",
    accessor: "unp",
  },
  // {
  //   Header: "Рег. номер судна",
  //   accessor: "regNum",
  // },
  {
    Header: "Участок",
    accessor: "sctName",
  },
  {
    Header: "Статус заявления",
    accessor: "statusName",
  },
  {
    Header: "Статус оплаты",
    accessor: "serviceStatus",
  },
];
export const DUPL_SHIPS_TICKET_COLUMNS = [
  {
    Header: "Рег. номер заявления",
    accessor: "appNum",
  },
  {
    Header: "Дата регистрации заявления",
    accessor: "operDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "ФИО",
    accessor: "fio",
  },
  {
    Header: "Ид. номер заявителя",
    accessor: "persNum",
  },
  {
    Header: "Участок",
    accessor: "sctName",
  },
  {
    Header: "Статус заявления",
    accessor: "statusName",
  },
  {
    Header: "Статус оплаты",
    accessor: "serviceStatus",
  },
];
export const COLUMNS_FORM_SEARCH_BOAT_CARDS = [
  {
    Header: "Рег. номер судна",
    accessor: "regNum",
  },
  {
    Header: "Зав. номер судна",
    accessor: "boatVin",
  },
  {
    Header: "ФИО Собственника",
    accessor: "fio",
  },
  {
    Header: "Идентификационный номер",
    accessor: "ownerPersNum",
  },
  {
    Header: "Наименование организации",
    accessor: "leName",
  },
  {
    Header: "УНП",
    accessor: "unp",
  },
  {
    Header: "Номер судового билета",
    accessor: "tiketNum",
  },
];
export const COLUMNS_FORM_SEARCH_BOAT_CARDS_DUPLICATES = [
  {
    Header: "Рег. номер судна",
    accessor: "regNum",
  },
  {
    Header: "Зав. номер судна",
    accessor: "boatVin",
  },
  {
    Header: "ФИО Собственника",
    accessor: "fio",
  },
  {
    Header: "Идентификационный номер",
    accessor: "ownerPersNum",
  },
  {
    Header: "Номер судового билета",
    accessor: "tiketNum",
  },
];

export const SHIPS_TICKET_COLUMNS = [
  // {
  //   Header: "Рег. номер заявления",
  //   accessor: "appNum",
  // },
  // {
  //   Header: "Дата регистрации заявления",
  //   accessor: "operDate",
  // },
  {
    Header: "ФИО",
    accessor: "fio",
  },
  {
    Header: "Ид. номер заявителя",
    accessor: "persNum",
  },
  {
    Header: "Наим. организации",
    accessor: "nameLe",
  },
  {
    Header: "УНП",
    accessor: "unp",
  },
  {
    Header: "Судовой билет №",
    accessor: "tiketNum",
  },
  // {
  //   Header: "Рег. номер судна",
  //   accessor: "regNum",
  // },
  {
    Header: "Участок",
    accessor: "sctName",
  },
  {
    Header: "Статус заявления",
    accessor: "statusName",
  },
];

export const PROVISION_INFORMATION_COLUMNS = [
  {
    Header: "Рег. номер заявления",
    accessor: "appNum",
  },
  {
    Header: "Дата регистрации заявления",
    accessor: "operDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "ФИО",
    accessor: "fio",
  },
  {
    Header: "Ид. номер заявителя",
    accessor: "persNum",
  },
  {
    Header: "Наим. организации",
    accessor: "nameLe",
  },
  {
    Header: "УНП",
    accessor: "unp",
  },
  {
    Header: "Участок",
    accessor: "sctName",
  },
  {
    Header: "Статус заявления",
    accessor: "statusName",
  },
];

export const TRANSPORT_ACCIDENT_COLUMNS = [
  {
    Header: "Дата",
    accessor: "incidentDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Место транспортного аварийного случая",
    accessor: "incidentPlace",
  },
  {
    Header: "Участок",
    accessor: "sctName",
  },
  {
    Header: "Судовладелец",
    accessor: "owner",
  },
  {
    Header: "Рег. номер",
    accessor: "boatRegNum",
  },
  {
    Header: "Причина",
    accessor: "incidentReasons",
  },
  {
    Header: "Вид транспортного аварийного случая",
    accessor: "incidentType",
  },
  {
    Header: "Количество спасенных",
    accessor: "saveNum",
  },
  {
    Header: "Количество погибших",
    accessor: "deadTotal",
  },
  {
    Header: "Погибших в состоянии алкогольного опьянения",
    accessor: "deadDrunk",
  },
  {
    Header: "Статус дела",
    accessor: "incidentStatus",
  },
];
export const TECHNICAL_EXAMINATON_COLUMNS = [
  {
    Header: "Рег. номер заявления",
    accessor: "appNum",
  },
  {
    Header: "Дата регистрации заявления",
    accessor: "appDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "ФИО",
    accessor: "fio",
  },
  {
    Header: "Ид. номер заявителя",
    accessor: "ownerPersNum",
  },
  {
    Header: "Наим. организации",
    accessor: "leName",
  },
  {
    Header: "УНП",
    accessor: "leUnp",
  },
  {
    Header: "Участок",
    accessor: "sctName",
  },
  {
    Header: "Статус заявления",
    accessor: "statusName",
  },
  {
    Header: "Статус оплаты",
    accessor: "billServiceStatus",
  },
];

export const AUDIT_ACTIONS_SYSTEM = [
  {
    Header: "Номер",
    accessor: "logDocNum",
  },
  {
    Header: "Объект",
    accessor: "objectName",
  },
  {
    Header: "Дата, время",
    accessor: "logDate",
  },
  {
    Header: "Событие",
    accessor: "logAction",
  },
  {
    Header: "Описание",
    accessor: "logNote",
  },
  {
    Header: "Пользователь",
    accessor: "logUser",
  },
  {
    Header: "IP",
    accessor: "logUserIp",
  },
  {
    Header: "MAC",
    accessor: "logHostMac",
  },
];
export const APPLICATION_TRAINING_COLUMNS = [
  {
    Header: "Рег. номер",
    accessor: "appNum",
  },
  {
    Header: "ФИО",
    accessor: "fio",
  },
  {
    Header: "Ид. номер заявителя",
    accessor: "persNum",
  },
  {
    Header: "Дата рождения",
    accessor: "birthDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Программа подготовки",
    accessor: "programName",
  },
  {
    Header: "Номер, дата договора",
    accessor: "contractNumAndDate",
  },
  {
    Header: "Номер счёта",
    accessor: "serviceBillId",
  },
  {
    Header: "Статус оплаты",
    accessor: "statusOfPaymentName",
  },
  {
    Header: "Участок",
    accessor: "sctName",
  },
];

export const EXPLUSION_ORDER_COLUMNS = [
  {
    Header: "Номер приказа",
    accessor: "orderNum",
  },
  {
    Header: "Дата приказа",
    accessor: "orderDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Период обучения с",
    accessor: "startDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Период обучения по",
    accessor: "endDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Программа  подготовки",
    accessor: "programName",
  },
  {
    Header: "Участок",
    accessor: "sectionName",
  },
];

export const REGISTER_OF_TRAINEES_COLUMNS = [
  {
    Header: "№",
    accessor: "appNum",
  },
  {
    Header: "Дата подачи заявления",
    accessor: "appDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "ФИО",
    accessor: "fio",
  },
  {
    Header: "Документ",
    accessor: "docTypeName",
  },
  {
    Header: "Серия",
    accessor: "serialOfPassport",
  },
  {
    Header: "Номер",
    accessor: "numberOfPassport",
  },
  {
    Header: "Кем выдан",
    accessor: "docDepartment",
  },
  {
    Header: "Дата выдачи",
    accessor: "docDateIssue",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Идентификационный номер",
    accessor: "persNum",
  },
  {
    Header:
      "Номер и дата выдачи, срок действия медицинской справки о состоянии  здоровья",
    accessor: "medDoc",
  },
  {
    Header: "Номер и дата заключения договора",
    accessor: "contractNumAndDate",
  },
  {
    Header: "Вид, серия, номер и дата выдачи документа об обучении",
    accessor: "trainingOrders",
  },
];
export const SEARCH_RECORD_TRAINED_USERS_COLUMNS = [
  {
    Header: "ФИО",
    accessor: "fio",
  },
  {
    Header: "Дата рождения",
    accessor: "birthDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);
      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Программа подготовки",
    accessor: "trainingProgName",
  },
  {
    Header: "Организация",
    accessor: "trainingOrgsName",
  },

  {
    Header: "Срок обучения",
    accessor: "daysOfStudy",
  },
  {
    Header: "Вид, серия, номер и дата док. об образовании",
    accessor: "docAboutEducation",
  },
];
export const RECORD_TRAINED_USER_LOGBOOK_COLUMNS = [
  {
    Header: "№",
    accessor: (row, index) => index + 1,
    Cell: (cellProps) => {
      return <div>{cellProps.row.index + 1}</div>;
    },
  },
  {
    Header: "Дата и место рождения",
    accessor: "dateAndBirthPlace",
  },
  {
    Header: "Фамилия, собственное имя, отчество (если такое имеется)",
    accessor: "fio",
  },
  {
    Header: "Идентификационный номер",
    accessor: "persNum",
  },
  {
    Header:
      "Организация (индивидуальный предприниматель), осуществляющая обучение",
    accessor: "trainingOrgsName",
  },
  {
    Header: "Срок обучения",
    accessor: "daysOfStudy",
  },
  {
    Header: "Вид, серия, номер документа об образовании (обучении)",
    accessor: "trainingDocumentsDocTypeNameAndDocName",
  },
  {
    Header: "Дата выдачи и номер удостоверения ",
    accessor: "licenseNumAndDate",
  },
  {
    Header: "Программа подготовки",
    accessor: "trainingProgName",
  },
];

export const APP_KNOWLEDGE_VERIFICATION_COLUMNS = [
  {
    Header: "Рег. номер",
    accessor: "appNum",
    // accessor: (row, index) => index + 1, // Функция для вычисления номера строки
    // Cell: (cellProps) => {
    //   return <div>{cellProps.row.index + 1}</div>;
    // },
  },
  {
    Header: "Период обучения",
    accessor: "periodOfStudy",
  },
  {
    Header: "ФИО",
    accessor: "fio",
  },
  {
    Header: "Дата рождения",
    accessor: "birthDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);
      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Участок",
    accessor: "section",
  },

  {
    Header: "Программа подготовки",
    accessor: "programName",
  },
  {
    Header: "Обучение или самоподготовка",
    accessor: "trainingSelfTraining",
  },
  {
    Header: "Номер, дата договора",
    accessor: "contractNumAndDate",
  },
  {
    Header: "Номер счета",
    accessor: "serviceBillId",
  },
  {
    Header: "Статус оплаты",
    accessor: "statusOfPaymentName",
  },
];
export const SEARCH_KNOWELEDGE_TEST_RECORD_COLUMNS = [
  {
    Header: "ФИО",
    accessor: "fio",
  },
  {
    Header: "Дата рождения",
    accessor: "birthDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);
      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Программа подготовки",
    accessor: "programName",
  },
  {
    Header: "Обучение или самоподготовка",
    accessor: "selfOfTraining",
  },
  {
    Header: "Период обучения",
    accessor: "periodOfStudy",
  },
  {
    Header: "Участок",
    accessor: "sectionName",
  },

  {
    Header: "Отметка,теория",
    accessor: "orally",
  },
  {
    Header: "Отметка,практика",
    accessor: "writing",
  },
  {
    Header: "Результат проверки",
    accessor: "resultOfChecking",
  },
];

export const SEARCH_ISSUING_CERTIFICATES_COLUMNS = [
  {
    Header: "Рег.номер заявления",
    accessor: "regNum",
  },
  {
    Header: "Дата регистрации",
    accessor: "regDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);
      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "ФИО",
    accessor: "fio",
  },
  {
    Header: "Дата рождения",
    accessor: "birthdate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);
      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Тип удостоверения",
    accessor: "typeName",
  },
  {
    Header: "Номер и дата выдачи удостоверения",
    accessor: "numberAndDate",
  },
  {
    Header: "Участок",
    accessor: "sectionName",
  },
  {
    Header: "Статус заявления",
    accessor: "statusName",
  },
  {
    Header: "Статус оплаты",
    accessor: "serviceStatus",
  },
];
export const SEARCH_ISSUING_CERTIFICATES_APPLICANT_COLUMNS = [
  {
    Header: "ФИО",
    accessor: "fio",
  },
  {
    Header: "Дата рождения",
    accessor: "birthdate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);
      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Период обучения",
    accessor: "dateStartEnd",
  },
  {
    Header: "Программа подготовки",
    accessor: "programSign",
  },
  {
    Header: "Номер и дата выдачи удостоверения",
    accessor: "numberAndDate",
  },
  {
    Header: "Участок",
    accessor: "sectionName",
  },
];

export const SEARCH_INSPECTION_TECHNICAL_CONDITION_BASES_COLUMNS = [
  {
    Header: "Сист. №",
    accessor: (row, index) => index + 1,
    Cell: (cellProps) => {
      return <div>{cellProps.row.index + 1}</div>;
    },
  },
  {
    Header: "Наименование эксплуатанта базы",
    accessor: "ownerLeName",
  },
  {
    Header: "Адрес и телефон эксплуатанта",
    accessor: "ownerAddressPhone",
  },
  {
    Header: "Местонахождение и телефон базы",
    accessor: "locationPhone",
  },
  {
    Header: "Дата обследования",
    accessor: "checkDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Результат обследования",
    accessor: "statusName",
  },
  {
    Header: "Участок",
    accessor: "sectionName",
  },
  {
    Header: "Примечание",
    accessor: "note",
  },
];
export const MODAL_WINDOW_HISTORY_PROTOCOLS_COLUMNS = [
  {
    Header: "Дата протокола",
    accessor: "protDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);
      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Номер протокола",
    accessor: "protNum",
  },

  {
    Header: "Программа подготовки",
    accessor: "programName",
  },
  {
    Header: "Период обучения",
    accessor: "periodOfStudy",
  },
  {
    Header: "Отметка",
    accessor: "passed",
  },
];

export const STRUCTURAL_UNITS_COLUMNS = [
  {
    Header: "Наименование",
    accessor: "depName",
    leftNoTitle: true,
  },
];

export const GIMS_SECTIONS_COLUMNS = [
  {
    Header: "Название участка",
    accessor: "sctName",
    leftNoTitle: true,
  },
  {
    Header: "Структурное подразделение",
    accessor: "depId.depName",
    leftNoTitle: true,
  },
  {
    Header: "Следующий номер  заявления на участке",
    accessor: "sctAppNum",
    leftNoTitle: true,
  },
  {
    Header: "Дата начала действия",
    accessor: "dateStart",
    leftNoTitle: true,
  },
  {
    Header: "Дата окончания  действия",
    accessor: "dateEnd",
    leftNoTitle: true,
  },
  {
    Header: "Описание участка",
    accessor: "sctNote",
    leftNoTitle: true,
  },
];
export const KINDS_BOATS_COLUMNS = [
  {
    Header: "Наименование",
    accessor: "name",
    leftNoTitle: true,
    onlySave: true,
  },
];
export const IDENTIFICATION_DOCUMENTS_COLUMNS = [
  {
    Header: "Наименование",
    accessor: "dtname",
    leftNoTitle: true,
    onlySave: true,
  },
];
export const BOAT_TYPES_COLUMNS = [
  {
    Header: "Типы маломерных судов",
    accessor: "btname",
    leftNoTitle: true,
    onlySave: true,
  },
  {
    Header: "Примечание",
    accessor: "btnote",
    leftNoTitle: true,
  },
];
export const ADMINISTRATIVE_DISTRICTS = [
  {
    Header: "Область",
    accessor: "oblastName",
    leftNoTitle: true,
  },
  {
    Header: "Участок",
    accessor: "sectionName",
    leftNoTitle: true,
  },
  {
    Header: "Район",
    accessor: "rayonName",
    leftNoTitle: true,
  },
  {
    Header: "Дата начала действия",
    accessor: "dateStart",
    leftNoTitle: true,
  },
  {
    Header: "Дата окончания действия",
    accessor: "dateEnd",
    leftNoTitle: true,
  },
  {
    Header: "Пользователь",
    accessor: "userName",
    leftNoTitle: true,
  },
  {
    Header: "Примечание",
    accessor: "note",
    leftNoTitle: true,
  },
];

export const POSITIONS_COLUMNS = [
  {
    Header: "Наименование",
    accessor: "posName",
    leftNoTitle: true,
  },
  {
    Header: "Уровень подчинённости",
    accessor: "levelId.lvlName",
    leftNoTitle: true,
  },
];

export const SWIMMING_DIFFICULTY_CATEGORY = [
  {
    Header: "Наименование",
    accessor: "sacName",
    leftNoTitle: true,
  },
  {
    Header: "Примечание",
    accessor: "sacNote",
    leftNoTitle: true,
  },
];

export const PREPARATION_PROGRAMS = [
  {
    Header: "Краткое наименование",
    accessor: "sign",
    leftNoTitle: true,
    onlyEdit: true,
  },
  {
    Header: "Наименование",
    accessor: "name",
    leftNoTitle: true,
    onlyEdit: true,
  },
];

export const PAYMENT_DETAILS_COLUMNS = [
  {
    Header: "Название (рус)",
    accessor: "name",
    leftNoTitle: true,
  },
  {
    Header: "Название (анг)",
    accessor: "nameEn",
  },
  {
    Header: "Реквизиты для оплаты",
    accessor: "requisites",
  },
  {
    Header: "Путь по ЕРИП",
    accessor: "erip",
  },
  {
    Header: "Базовая величина",
    accessor: "basicValue",
  },
];

export const SETTLEMENTS_COLUMNS = [
  {
    Header: "Область",
    accessor: "oblast",
    leftNoTitle: true,
  },
  {
    Header: "Район",
    accessor: "rayon",
  },
  {
    Header: "Категория населенного пункта",
    accessor: "categoryName",
  },
  {
    Header: "Наименование (рус)",
    accessor: "nameRu",
  },
  {
    Header: "Наименование (бел)",
    accessor: "nameBy",
  },
  {
    Header: "Дата начала действия",
    accessor: "datein",
  },
  {
    Header: "Дата окончания действия",
    accessor: "dateout",
  },
];

export const MED_CONDITIONS_COLUMNS = [
  {
    Header: "Наименование",
    accessor: "name",
    leftNoTitle: true,
  },
];

export const TRAINING_DOC_TYPES_COLUMNS = [
  {
    Header: "Наименование документа",
    accessor: "name",
    leftNoTitle: true,
  },
];

export const ENGINE_TYPES_COLUMNS = [
  {
    Header: "Наименование типа двигателя",
    accessor: "name",
    leftNoTitle: true,
  },
];

export const BOAT_BODY_MATERIAL_COLUMNS = [
  {
    Header: "Название",
    accessor: "matname",
    leftNoTitle: true,
  },
  {
    Header: "Примечание",
    accessor: "matnote",
    leftNoTitle: true,
  },
];

export const SEARCH_ACCOUNT_MANAGEMENT_COLUMNS = [
  {
    Header: "Фамилия, имя, отчество",
    accessor: "fio",
  },
  {
    Header: "Должность",
    accessor: "position",
  },
  {
    Header: "Структурное подразделение",
    accessor: "department",
  },
  {
    Header: "Участок ГИМС",
    accessor: "section",
  },
  {
    Header: "Телефон",
    accessor: "phone",
  },
  {
    Header: "Логин",
    accessor: "login",
  },
  {
    Header: "Дата регистрации",
    accessor: "recDate",
  },
  {
    Header: "Действует до",
    accessor: "validUntil",
  },
  {
    Header: "Блок",
    accessor: "blockedText",
  },
  {
    Header: "Причина блокировки",
    accessor: "blockReason",
  },
];
export const SEARCH_EXCHANGE_CERTIFICATES_COLUMNS = [
  {
    Header: "Рег.номер заявления",
    accessor: "appNum",
  },
  {
    Header: "Дата регистрации",
    accessor: "appDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);
      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "ФИО",
    accessor: "fio",
  },
  {
    Header: "Дата рождения",
    accessor: "birthDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);
      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Номер удостоверения",
    accessor: "licenseNum",
  },
  {
    Header: "Дата удостоверения",
    accessor: "licenseDate",
  },
  {
    Header: "Тип удостоверения",
    accessor: "licenseTypeName",
  },
  {
    Header: "Участок",
    accessor: "sectionName",
  },
  {
    Header: "Статус заявления",
    accessor: "statusName",
  },
  {
    Header: "Статус оплаты",
    accessor: "serviceStatus",
  },
];

export const SEARCH_DUPLICATE_CERTIFICATES_COLUMNS = [
  {
    Header: "Рег.номер заявления",
    accessor: "appNum",
  },
  {
    Header: "Дата регистрации",
    accessor: "appDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);
      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "ФИО",
    accessor: "fio",
  },
  {
    Header: "Дата рождения",
    accessor: "birthDate",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);
      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Номер удостоверения",
    accessor: "licenseNum",
  },
  {
    Header: "Дата удостоверения",
    accessor: "licenseDate",
  },
  {
    Header: "Тип удостоверения",
    accessor: "licenseTypeName",
  },
  {
    Header: "Участок",
    accessor: "sectionName",
  },
  {
    Header: "Статус заявления",
    accessor: "statusName",
  },
  {
    Header: "Статус оплаты",
    accessor: "serviceStatus",
  },
];

export const SEARCH_AUDIT_SECURITY_COLUMNS = [
  {
    Header: "Фамилия, имя, отчество",
    accessor: "logUser",
  },
  {
    Header: "Структурное подразделение",
    accessor: "department",
  },
  {
    Header: "Событие",
    accessor: "logEvent",
  },
  {
    Header: "Дата, время",
    accessor: "logDate",
  },
  {
    Header: "Описание",
    accessor: "logNote",
  },
  {
    Header: "IP",
    accessor: "logUserIp",
  },
  {
    Header: "MAC",
    accessor: "logHostMac",
  },
];

export const RANGE_MS = [
  {
    Header: "Название участка",
    accessor: "sctName",
    leftNoTitle: true,
  },
  {
    Header: "Серия",
    accessor: "series",
    leftNoTitle: true,
  },
  {
    Header: "Номер с",
    accessor: "numStart",
    leftNoTitle: true,
  },
  {
    Header: "Номер по",
    accessor: "numEnd",
    leftNoTitle: true,
  },
  {
    Header: "Дата начала",
    accessor: "dateStart",
    leftNoTitle: true,
  },
  {
    Header: "Дата окончания",
    accessor: "dateEnd",
    leftNoTitle: true,
  },
  {
    Header: "Осталось номеров",
    accessor: "balance",
    leftNoTitle: true,
  },
];

export const COUNTRIES_COLUMNS = [
  {
    Header: "Полное наименование (рус.)",
    accessor: "countryFullname",
    leftNoTitle: true,
  },
  {
    Header: "Краткое наименование (рус.)",
    accessor: "countryName",
    leftNoTitle: true,
  },
  {
    Header: "Полное наименование (англ.)",
    accessor: "countryFullnameEn",
    leftNoTitle: true,
  },
  {
    Header: "Краткое наименование  (англ.)",
    accessor: "countryNameEn",
    leftNoTitle: true,
  },
  {
    Header: "Код страны",
    accessor: "countryCode",
    leftNoTitle: true,
  },
];

export const ORGANIZATIONS_COLUMNS = [
  {
    Header: "Полное наименование",
    accessor: "name",
    leftNoTitle: true,
  },
  {
    Header: "Краткое наименование",
    accessor: "shortName",
    leftNoTitle: true,
  },
  {
    Header: "Адрес",
    accessor: "address",
    leftNoTitle: true,
  },
  {
    Header: "Телефон",
    accessor: "phone",
    leftNoTitle: true,
  },
];
